import moment from 'moment';
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Form, Field } from 'react-final-form'
import { SingleDatePicker } from 'react-dates'
import Lock from 'react-feather/dist/icons/lock'
import { HeadingPrimary } from 'Styles/Typography'
import { NoPermissionStyles, FormWrapper } from './Styles'
import {
  Button,
  FormFieldWrapper,
  FieldLabel,
  FieldHint,
  FinalInput,
  FieldError,
  FormActionsWrapper,
  SweetAlert,
  toFinalFormDates
} from 'Components'
import { add } from 'Services/Firebase'

const validate = values => {
  const errors = {}
  if (!values.fogiOrderNo) {
    errors.fogiOrderNo = 'Required'
  }

  if (!values.insuranceClaimNo) {
    errors.insuranceClaimNo = 'Required'
  }

  if (!values.dateWorkCompleted) {
    errors.dateWorkCompleted = 'Required'
  }

  if (!values.clientEmail) {
    errors.clientEmail = 'Required'
  }

  if (!values.clientFullname) {
    errors.clientFullname = 'Required'
  }

  if (!values.plumberEmail) {
    errors.plumberEmail = 'Required'
  }

  if (values.plumberEmail && values.plumberEmail === values.clientEmail) {
    errors.plumberEmail = 'Client email cannot be the same as plumber email'
  }

  return errors
}

const NoPermission = () => (
  <NoPermissionStyles>
    <Lock size={50} />
    <HeadingPrimary>No Permission</HeadingPrimary>
    <p>You have no permissions to access this page. If you are not logged in <Link to='/'>click here to login.</Link> </p>
  </NoPermissionStyles>
)

class CreateClaimContainer extends Component {
  state = {
    completed: false,
    error: null
  }

  submit = async ({ dateWorkCompleted, ...rest }) => {
    const id = await add('claims', {
      ...rest,
      dateWorkCompleted: dateWorkCompleted.format('DD-MM-YYYY')
    });
    this.setState({
      completed: true,
      error: id ? null : 'Failed to submit form.'
    })
  }

  closeDialog = cb => this.setState({ completed: false, error: null }, () => cb && cb())

  render() {
    const { error, completed } = this.state

    if (!window.localStorage.getItem('uid'))
      return <NoPermission />

    return (
      <FormWrapper>
        <HeadingPrimary>FOGI Clearance</HeadingPrimary>
        { error && <FieldError>{ error }</FieldError> }
        <Form
          validate={ validate }
          initialValues={ { dateWorkCompleted: moment() } }
          onSubmit={ this.submit }
        >
          {
            ({ handleSubmit, submitting, form }) => (
              <form onSubmit={ handleSubmit }>
                <FormFieldWrapper>
                  <FieldLabel>Fogi Order No.</FieldLabel>
                  <Field
                    name='fogiOrderNo'
                    component={ FinalInput }
                    type='text'
                  />
                </FormFieldWrapper>
                <FormFieldWrapper>
                  <FieldLabel>Insurance Claim No.</FieldLabel>
                  <Field
                    name='insuranceClaimNo'
                    component={ FinalInput }
                    type='text'
                  />
                </FormFieldWrapper>
                <FormFieldWrapper>
                  <FieldLabel>Date work completed</FieldLabel>
                  <Field
                    block
                    numberOfMonths={ 1 }
                    name='dateWorkCompleted'
                    displayFormat='DD-MM-YYYY'
                    isOutsideRange={ day => (moment().diff(day) < 0) }
                    component={ toFinalFormDates(SingleDatePicker) }
                  />
                </FormFieldWrapper>
                <FormFieldWrapper>
                  <FieldLabel>Client full name</FieldLabel>
                  <Field
                    name='clientFullname'
                    component={ FinalInput }
                    type='text'
                  />
                </FormFieldWrapper>
                <FormFieldWrapper>
                  <FieldLabel>Client email address</FieldLabel>
                  <Field
                    name='clientEmail'
                    component={ FinalInput }
                    type='text'
                  />
                </FormFieldWrapper>
                <FormFieldWrapper>
                  <FieldLabel>Plumber email address</FieldLabel>
                  <FieldHint>This is the email address to where the completed clearance certificate will be sent to.</FieldHint>
                  <Field
                    name='plumberEmail'
                    component={ FinalInput }
                    type='text'
                  />
                </FormFieldWrapper>
                <FormActionsWrapper>
                  <Button
                    fullWidth
                    type='submit'
                    processing={ submitting }
                  >
                    Send claim form
                  </Button>
                </FormActionsWrapper>
                <SweetAlert
                  isOpen={ completed }
                  success={ !error }
                  danger={ error }
                  showCancel
                  title={ error ? 'Error' : 'Success' }
                  text={ error || 'Do you want to create another certificate?' }
                  confirmBtnText={ error ? 'Okay' : 'Yes' }
                  cancelBtnText={ error ? 'Cancel' : 'No' }
                  onConfirm={ () => this.closeDialog(form.reset) }
                  onCancel={ () => this.closeDialog() }
                />
              </form>
            )
          }
        </Form>
      </FormWrapper>
    )
  }
}

export default CreateClaimContainer



// WEBPACK FOOTER //
// ./src/Containers/CreateClaimContainer.jsx